import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: JSON.parse(localStorage.getItem("user")) || [],
  previewModeEnabled: false,
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    logIn: (state, action) => {
      state.user = { ...state.user, ...action.payload };

      localStorage.setItem("user", JSON.stringify(state.user));
      localStorage.setItem("token", state.user.token);
      localStorage.setItem("refreshToken", state.user.refreshToken);
    },
    RefreshToken: (state, action) => {
      state.user = { ...state.user, ...action.payload };
      localStorage.setItem("user", JSON.stringify(state.user));
    },
    updateUser: (state, action) => {
      state.user = { ...state.user, ...action.payload };
      localStorage.setItem("user", JSON.stringify(state.user));
    },
    logOut: (state) => {
      state.user = [];
      localStorage.removeItem("user");
      localStorage.removeItem("token");
      localStorage.removeItem("refreshToken");
    },
    updatePreviewMode: (state, action) => {
      state.previewModeEnabled = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { logIn, logOut, updateUser, RefreshToken, updatePreviewMode } =
  userSlice.actions;

export default userSlice.reducer;
